<template>

  <day-base-bar>
    <div class="fill-height text-center" style="background-color: rgb(from #5456aa r g b / 40%)">
      PARCS ({{ item.completed + item.opened }})
    </div>
  </day-base-bar>

</template>

<script setup lang="ts">

import DayBaseBar from './DayBaseBar.vue'
import type { DayParcsInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: DayParcsInventoryCalendarItem
}

defineProps<Props>()

</script>
